module.exports = __webpack_public_path__ + "prod/1.42.2/img/personnel-six.799c3c33.png";